import { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { Loader2, AlertCircle } from "lucide-react";

export default function SpreadsheetConnectorCallback() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const status       = searchParams.get("status");
    const credentialId = searchParams.get("id");
    const documentStoreId = sessionStorage.getItem("sc_document_store_id");

    if (status !== "success" || !credentialId) {
      setError("Google authorization failed or was cancelled. Please try again.");
      return;
    }

    if (!documentStoreId) {
      setError("Session expired. Please return to your document store and connect again.");
      return;
    }

    sessionStorage.removeItem("sc_document_store_id");
    sessionStorage.setItem("sc_credential_id", credentialId);
    navigate(`/files/${documentStoreId}/spreadsheet-connector`, { replace: true });
  }, [searchParams, navigate]);

  if (error) {
    return (
      <div className="flex flex-col items-center justify-center min-h-screen gap-3 text-center px-4">
        <div className="w-12 h-12 bg-red-100 rounded-full flex items-center justify-center">
          <AlertCircle className="w-6 h-6 text-red-600" />
        </div>
        <p className="text-sm font-medium text-gray-800">{error}</p>
      </div>
    );
  }

  return (
    <div className="flex items-center justify-center min-h-screen gap-2 text-gray-500">
      <Loader2 className="w-5 h-5 animate-spin" />
      <span className="text-sm">Redirecting…</span>
    </div>
  );
}
